import ViewFactory from "../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../utils";
import ErrorState from "../../common/error";
import { traverseDataFields } from "../../../charge/handler/helpers";
import getChargeData from "../../../init/chargedata";
import EventLog from "../../../logger/events";
import Mixpanel from "../../../init/mixpanel";
import { parentWindow, hasParent, isWindowOpen } from "../../../init/window";
import { getParams } from "../../../init/searchparams";

export default function view() {
    const $this = isPlainObject(this) ? this : Object.create(null);

    return ViewFactory({
        NAME: 'PENDING_VIEW',

        mount() {
            Object.keys($this).length > 0 && !!$this.dispatch ? $this.dispatch(ErrorState.actions.updateErrorMessage()) : void 0;

            const { $$data: data1, data: data2 } = this;
            const $data = isPlainObject(data1) ? data1 : isPlainObject(data2) ? data2 : null;
            const $tx = (traverseDataFields($data, 'tx').tx || traverseDataFields($data, 'data').data || $data) || null;

            EventLog.transactionPending();

            (cb => (Mixpanel.mixpanelInitialized()
            ? Mixpanel.pendingPayment().finally(() => cb())
            : Promise.resolve().then(() => cb())
            ))(() => {
                if (hasParent || isWindowOpen) {
                    try {
                        parentWindow.postMessage({
                        name: $data.name || 'opop',
                        data: $data,
                        tx: $tx,
                        success: true
                        }, '*');
                        return;
                    } catch (e) {}
                }

                setTimeout(function() {
                    getChargeData().then($chargedata => {
                    try {
                        const red_url = getValueAtPath($chargedata, 'redirect_url');
                        const tx_ref = getValueAtPath($chargedata, 'txref');

                        if (red_url && tx_ref) {
                        const redirect = new URL(red_url);
                        const redirectParams = redirect.searchParams;

                        if ($chargedata.use_v3 === true) {
                            const { transaction_id, status } = traverseDataFields($tx, 'id::transaction_id', 'status');

                            redirectParams.set('status', status || 'pending');
                            redirectParams.set('tx_ref', tx_ref);
                            redirectParams.set('transaction_id', transaction_id || null);
        
                            EventLog.redirectingToMerchant($tx)
                            .finally(() => window.location.href = redirect.href);
                        } else {
                            const {
                            redirect_post,
                            redirect_no_json
                            } = getParams('redirect_post', 'redirect_no_json');

                            const method = +redirect_post ? 'POST' : 'GET';

                            if (method === 'GET' && +redirect_no_json) {
                                EventLog.redirectingToMerchant($tx)
                                .finally(() => window.location.href = redirect.href);
                                return;
                            }

                            const $form = document.createElement('form');
                            const $textarea = document.createElement('textarea');

                            $textarea.setAttribute('name', 'resp');
                            $textarea.setAttribute('hidden', 'hidden');
                            $textarea.setAttribute('readonly', 'readonly');
                            $textarea.classList.add('sr-only');

                            $textarea.value = JSON.stringify($data);

                            $form.setAttribute('method', method);
                            $form.setAttribute('action', redirect.href);
                            $form.setAttribute('hidden', 'hidden');
                            $form.classList.add('sr-only');

                            $form.appendChild($textarea);
                            document.body.appendChild($form);

                            EventLog.redirectingToMerchant($tx)
                            .finally(() => $form.submit());
                        }
                        }
                    } catch (e) {}
                    });
                }, 5000);
            });
        }
    }).call(this);
}
